import service from '@/utils/server';

const baseURL = process.env.BASE_URL;
const modName = '/bd/trackDelivery/';
//图片预览完整URL(拼接 BASE_URL + ImageController 路径)
export const getImagePreviewUrl = fileCode => baseURL + '/common/web/image/preview/' + fileCode;
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//编辑详情
export const detailInfo = data => {
  return service({
    url: modName + 'detail',
    method: 'post',
    data
  });
};
//编辑提交
export const editSubmit = data => {
  return service({
    url: modName + 'editSubmit',
    method: 'post',
    data
  });
};
//批量删除
export const deleteBatch = data => {
  return service({
    url: modName + 'deleteBatch',
    method: 'post',
    data
  });
};
//导出
export const exportData = data => {
  let config = {
    timeout: 500000,
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};
//批量修改导出(按用户勾选的 deliveryNo + fields 批量输出 Excel)
export const batchEditExport = data => {
  let config = {
    timeout: 500000,
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'batchEditExport',
    method: 'post',
    data
  });
};
//回单图片 ZIP 导出(按用户勾选的 deliveryNoList;只导出已回单的送货单;zip 内附 _export_manifest.csv)
export const exportReceiptZip = data => {
  let config = {
    timeout: 500000,
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'exportReceiptZip',
    method: 'post',
    data
  });
};
//订单导入
export const orderImport = data => {
  let config = {
    timeout: 500000,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'trackDeliveryImport',
    method: 'post',
    data
  });
};
//仓库发货导入
export const warehouseShipImport = data => {
  let config = {
    timeout: 500000,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'warehouseShipImport',
    method: 'post',
    data
  });
};
//运输商调整导入
export const transportCarrierImport = data => {
  let config = {
    timeout: 500000,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'transportCarrierImport',
    method: 'post',
    data
  });
};
//签收信息导入
export const signingImport = data => {
  let config = {
    timeout: 500000,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'trackSignImport',
    method: 'post',
    data
  });
};
//回单压缩包批量上传
export const receiptUploadImport = data => {
  let config = {
    timeout: 500000,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return service({
    ...config,
    url: modName + 'receiptUploadImport',
    method: 'post',
    data
  });
};
//回单上传
export const receiptUpload = data => {
  let config = {
    timeout: 500000,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return service({
    ...config,
    url: modName + 'receiptUpload',
    method: 'post',
    data
  });
};
//合并回单压缩包上传
export const mergeReceiptUpload = data => {
  let config = {
    timeout: 500000,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  };
  return service({
    ...config,
    url: modName + 'mergeReceiptUpload',
    method: 'post',
    data
  });
};
//快递单导入
export const expressImport = data => {
  let config = {
    timeout: 500000,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: 'blob'
  };
  return service({
    ...config,
    url: modName + 'expressImport',
    method: 'post',
    data
  });
};

//回单文件信息列表(根据送货单号)
export const receiptFileList = data => {
  return service({
    url: modName + 'receiptFileInfoList/' + data.deliveryNo,
    method: 'get',
    data
  });
};

//
export const delayReasonImport = data => {
  let config = {
    timeout: 500000,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'delayReasonImport',
    method: 'post',
    data
  });
};
//批量修改导入
export const batchEditImport = data => {
  let config = {
    timeout: 500000,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'batchEditImport',
    method: 'post',
    data
  });
};
//批量车辆导入
export const truckImport = data => {
  let config = {
    timeout: 500000,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'truckImport',
    method: 'post',
    data
  });
};

//模板下载
export const downLoadTemplate = data => {
  let config = {
    timeout: 500000,
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};

//行编辑查询:按 deliveryNo 拉 13 业务字段 + late 子表
export const getForEdit = data => {
  return service({
    url: modName + 'getForEdit',
    method: 'post',
    data
  });
};

//行编辑提交
export const submitRowEdit = data => {
  return service({
    url: modName + 'submitRowEdit',
    method: 'post',
    data
  });
};

//按 (deliveryNo, fileCode) 删除单张回单图片
export const deleteReceiptFile = data => service({
  url: modName + 'deleteReceiptFile',
  method: 'post',
  data
});



// WEBPACK FOOTER //
// ./src/page/track/api/index.js